import fb from './../facebook.png';
import tt from './../Tik tok.png';
import lin from './../linkedin.png';
import yt from './../youtube.png';
import insta from './../instagram.png';
import twi from './../twitter.png';

export const dates = [{
    title: 'Centro de soporte',
    dates: ['930 754 024', '934 316 962', '(01) 6478101']
}, {
    title: 'Legal',
    dates: ['Política de Privacidad', 'Términos & Condiciones']
}];

export const iconDates = [
    {
        link: 'https://www.facebook.com/ICSMCIENTIFICO',
        img: fb
    },
    {
        link: 'https://www.tiktok.com/@icsm_cientifico',
        img: tt
    },
    {
        link: 'https://www.linkedin.com/company/71868312/admin/',
        img: lin   
    },
    {
        link: 'https://www.youtube.com/channel/UCzRVTsjxtrKqrRCPSNOejpQ',
        img: yt
    },
    {
        link: 'https://www.instagram.com/icsmcientifico/?hl=es-la',
        img: insta   
    },
    {
        link: 'https://x.com/CientificoIcsm',
        img: twi
    }
]